import styles from './VacancyCard.module.scss'
import Layout from "../../ui/Layout/Layout"
import { ComponentProps, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Button from '../../ui/Button/Button'
import { ITransformedVacancy, TSource } from '../../utils'
import clsx from 'clsx'

import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkIcon from '@mui/icons-material/Work';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import useGetIcon from '../../hooks/useGetIcon'
import useVisitedVacancy from '../../hooks/vacancies/useVisitedVacancy'
import StarIcon from '@mui/icons-material/Star';
import useFavouriteVacancy from '../../hooks/vacancies/useFavouriteVacancy'
import { useIsVisible } from '../../hooks/common'


export interface IVacancyCardProps extends ComponentProps<"div"> {
  vacancy: ITransformedVacancy
}

const VacancyCard = (props: IVacancyCardProps) => {
  const { vacancy, className, ...args } = props


  const addVisited = useVisitedVacancy()
  const [isHidden, setIsHidden] = useState(false)
  const isVisited = useMemo(() => {
    return isHidden || vacancy.visited
  }, [vacancy, isHidden])


  const addFavoirite = useFavouriteVacancy();
  const [isFavourite, setIsFavourite] = useState(vacancy?.favourite || false);
  useEffect(() => {
    setIsFavourite(vacancy.favourite)
  }, [vacancy])


  const icon = useGetIcon(vacancy.source as TSource)

  const hideVacancy = useCallback(() => {
    if (!isVisited) {
      addVisited.mutate(vacancy.id, {onSuccess: () => setIsHidden(true)})
    }
  }, [vacancy, isVisited])

  const wasVisible = useRef(false)
  const onShow = useCallback(() => {
    wasVisible.current = true
  }, [])
  const onHide = useCallback(() => {
    if (wasVisible.current) {
      hideVacancy()
    }
  }, [wasVisible.current, hideVacancy])
  useIsVisible(
    vacancy.id, 
    onShow,
    onHide,
    1
  )


  return (
    <Layout key={vacancy.id} id={vacancy.id} className={clsx(styles.root, className)} kind={'white'} {...args}>
      <VisibilityOffIcon 
        className={styles.visibility}
        onClick={hideVacancy}
        style={{
          opacity: isVisited ? '1' : '.3'
        }}
      />
      <div className={styles.title}> <h2>{vacancy.name}</h2> </div>
      <div className={styles.employment}><h3>{vacancy.employment}</h3></div>
      <p className={styles.time}>
        <StarIcon 
          className={styles.favourite}
          onClick={() => {
            addFavoirite.mutate({id: vacancy.id, isFauvorite: !vacancy.favourite}, {onSuccess: () => setIsFavourite(cur => !cur)})
          }}
          style={{
            opacity: isFavourite ? '1' : '.3',
          }}
        />
        <p className='small'>{vacancy.createdAt} </p>
        <img className={styles.source} src={icon}/>
      </p>

      <div className={styles.contentWrap}>

        <div className={styles.left}>
          <p className={styles.salary}>{vacancy.salary} <MonetizationOnIcon/> </p>
          <p className={styles.company}>{vacancy.employer} <WorkIcon/></p>
        </div>

        <div className={styles.right}>
          <p className={styles.city}><LocationCityIcon/> {vacancy.city}</p>
          <p className={styles.experience}><AccessTimeFilledIcon/> {vacancy.experience}</p>
        </div>

      </div>

      <Button 
        className={styles.btn} 
        kind={isVisited ? 'white' : 'red'}
        onClick={() => {
          window.open(vacancy.url, '_blank')
          hideVacancy()
        }}
      >
        Перейти к вакансии
      </Button>
    </Layout>
  )
}

export default VacancyCard